import React, { FC } from "react";
import { PreviewItemProps, UploadInputProps } from "../types";
import { UploadInput } from "../UploadInput";
import { DropZoneImageUploadContainer } from "./DropZoneImageUploadContainer";
import { PreviewImage } from "./PreviewImage";
import { SimpleUploadButton } from "./SimpleUploadButton";

type DropZoneImageUploadProps = {
  slotProps?: {
    previewItem?: PreviewItemProps;
  };
};

/**
 * Dropzone image upload component
 */
export const DropZoneImageUpload: FC<Omit<UploadInputProps, "slots"> & DropZoneImageUploadProps> = (props) => (
  <UploadInput
    {...props}
    slots={{
      container: DropZoneImageUploadContainer,
      previewItem: PreviewImage,
      upload: SimpleUploadButton,
    }}
  />
);
